import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function PrintOrder() {
  return <div className="min-h-screen bg-white p-8 max-w-4xl mx-auto" data-id="element-623">
      <div className="mb-8 print:hidden" data-id="element-624">
        <Button onClick={() => window.print()} className="gap-2" data-id="element-625">
          <Printer className="h-4 w-4" data-id="element-626" />
          Print Order
        </Button>
      </div>

      <div className="border border-slate-200 p-8 space-y-8" data-id="element-627">
        {/* Header */}
        <div className="flex justify-between items-start" data-id="element-628">
          <div data-id="element-629">
            <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-630">
              Desert Sage Seminars
            </h1>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-631">
              <p data-id="element-632">123 Education Lane</p>
              <p data-id="element-633">Phoenix, AZ 85001</p>
              <p data-id="element-634">CALL US: (555) 123-4567</p>
              <p data-id="element-635">Fax: (555) 987-6543</p>
              <p data-id="element-636">E-Mail: info@desertsageseminars.com</p>
            </div>
          </div>
          <div className="text-right text-sm space-y-1" data-id="element-637">
            <p data-id="element-638">
              <span className="font-semibold" data-id="element-639">Date:</span> 2023-10-15
            </p>
            <p data-id="element-640">
              <span className="font-semibold" data-id="element-641">Order id:</span> ORD-2023-001
            </p>
            <p data-id="element-642">
              <span className="font-semibold" data-id="element-643">Order status:</span> Processed
            </p>
          </div>
        </div>

        <hr className="border-slate-200" data-id="element-644" />

        {/* Customer Info */}
        <div className="grid grid-cols-2 gap-8" data-id="element-645">
          <div data-id="element-646">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-647">Customer Info</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-648">
              <p data-id="element-649">
                <span className="font-semibold" data-id="element-650">Company:</span> Acme Landscaping
              </p>
              <p data-id="element-651">
                <span className="font-semibold" data-id="element-652">First Name:</span> John
              </p>
              <p data-id="element-653">
                <span className="font-semibold" data-id="element-654">Last Name:</span> Doe
              </p>
              <p data-id="element-655">
                <span className="font-semibold" data-id="element-656">Phone:</span> 555-0123
              </p>
              <p data-id="element-657">
                <span className="font-semibold" data-id="element-658">Fax:</span> -
              </p>
              <p data-id="element-659">
                <span className="font-semibold" data-id="element-660">E-Mail:</span> john@example.com
              </p>
              <p data-id="element-661">
                <span className="font-semibold" data-id="element-662">URL:</span> -
              </p>
            </div>
          </div>
          <div data-id="element-663">
            <h3 className="font-bold text-slate-900 mb-2" data-id="element-664">Billing Address</h3>
            <div className="text-sm text-slate-600 space-y-1" data-id="element-665">
              <p data-id="element-666">
                <span className="font-semibold" data-id="element-667">Address:</span> 123 Desert Way
              </p>
              <p data-id="element-668">
                <span className="font-semibold" data-id="element-669">City:</span> Phoenix
              </p>
              <p data-id="element-670">
                <span className="font-semibold" data-id="element-671">State:</span> AZ
              </p>
              <p data-id="element-672">
                <span className="font-semibold" data-id="element-673">Zip:</span> 85001
              </p>
            </div>
          </div>
        </div>

        {/* Products Table */}
        <table className="w-full text-sm text-left border-collapse" data-id="element-674">
          <thead data-id="element-675">
            <tr className="bg-slate-50 border-y border-slate-200" data-id="element-676">
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-677">SKU</th>
              <th className="py-2 px-4 font-semibold text-slate-900" data-id="element-678">
                Product
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-679">
                Item price
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-center" data-id="element-680">
                Quantity
              </th>
              <th className="py-2 px-4 font-semibold text-slate-900 text-right" data-id="element-681">
                Total
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200" data-id="element-682">
            <tr data-id="element-683">
              <td className="py-3 px-4" data-id="element-684">C-101</td>
              <td className="py-3 px-4" data-id="element-685">Desert Ecology Basics</td>
              <td className="py-3 px-4 text-right" data-id="element-686">$49.00</td>
              <td className="py-3 px-4 text-center" data-id="element-687">1</td>
              <td className="py-3 px-4 text-right" data-id="element-688">$49.00</td>
            </tr>
          </tbody>
        </table>

        {/* Totals */}
        <div className="flex justify-end" data-id="element-689">
          <div className="w-64 space-y-2 text-sm" data-id="element-690">
            <div className="flex justify-between" data-id="element-691">
              <span className="text-slate-600" data-id="element-692">Subtotal:</span>
              <span className="font-medium" data-id="element-693">$49.00</span>
            </div>
            <div className="flex justify-between" data-id="element-694">
              <span className="text-slate-600" data-id="element-695">Coupon saving (SUMMER23):</span>
              <span className="font-medium text-green-600" data-id="element-696">-$10.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-200 pt-2" data-id="element-697">
              <span className="text-slate-600" data-id="element-698">Discounted subtotal:</span>
              <span className="font-medium" data-id="element-699">$39.00</span>
            </div>
            <div className="flex justify-between border-t border-slate-900 pt-2 text-base font-bold" data-id="element-700">
              <span data-id="element-701">Total:</span>
              <span data-id="element-702">$39.00</span>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-slate-200 text-center" data-id="element-703">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-50 rounded border border-slate-200" data-id="element-704">
            <span className="font-bold text-slate-700" data-id="element-705">Authorize.Net</span>
            <span className="text-xs text-slate-500" data-id="element-706">
              Secure Payment Processing
            </span>
          </div>
        </div>
      </div>
    </div>;
}